module.exports = __webpack_public_path__ + "media/images/countrysquared/mg-9062a30a81cdb253cbda576413eb4ba9.svg";